export const shippingServices = (state) => state.shippingServices
export const storeShippingConfigs = (state) => state.storeShippingConfigs
export const availableShippingServices = (state) => state.availableShippingServices
